<template>
  <div :class="$style.wrapper">
    <div :class="$style.inner">
      <table :class="{ 'table': true, 'disabled': disabled }">
        <tbody>
        <tr>
          <td></td>
          <td v-for="(name, colIndex) in heading" :key="colIndex">
            {{name}}
          </td>
        </tr>
        <tr v-for="(name, rowIndex) in heading" :key="rowIndex">
          <td>{{name}}</td>
          <td v-for="(name, colIndex) in heading" :key="colIndex" :class="{ 'grey': colIndex === rowIndex }">
            <Check
              v-if="colIndex !== rowIndex"
              :checked="table[rowIndex][colIndex]"
              @click="() => toggle(rowIndex, colIndex)"
            />
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <transition name="fade">
      <Button wide @click="emit" v-if="ready && !disabled" :class="$style.button">
        Продолжить
      </Button>
    </transition>
  </div>
</template>
<script>
import isEqual from 'lodash/isEqual'

import Check from '@/components/@ui/Check/Check.vue'
import Button from '@/components/@ui/Button/Button.vue'

import Bus from '../../Bus'

const rightTable = [
  [false, true, true, false, false, false, false, false],
  [true, false, true, false, false, false, false, false],
  [true, true, false, true, false, false, false, false],
  [false, false, true, false, false, false, false, false],
  [false, false, false, false, false, true, true, false],
  [false, false, false, false, true, false, true, false],
  [false, false, false, false, true, true, false, true],
  [false, false, false, false, false, false, true, false],
]

export default {
  name: 'StackedTable',
  components: { Check, Button },
  props: {
    heading: Array,
    initial: Array,
    disabled: Boolean,
  },
  data() {
    return {
      table: this.initial || this.heading.map(() => this.heading.map(() => false)),
      ready: false,
    }
  },
  watch: {
    table() {
      this.ready = isEqual(this.table, rightTable)
    },
  },
  methods: {
    toggle(rowIndex, colIndex) {
      const newTable = this.table.slice()
      newTable[rowIndex][colIndex] = !this.table[rowIndex][colIndex]
      this.table = newTable
    },
    emit() {
      if (this.ready) {
        Bus.$emit('stackedTableReady', this.table)
      }
    },
  },
}
</script>
<style lang="scss" module>
@import './StackedTable.scss';
</style>
